import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { TICKET_CREATE } from 'router/routes';

import CreateTicketForm from '../CreateTicket/components/CreateTicketForm';
import Button from 'components/Button/Button';

import useStyles from '../CreateTicket/styles';

interface IProps {
  useTeamsStyles?: boolean;
}

const CreateTicketFormPage: React.FC<IProps> = ({ useTeamsStyles = false }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(TICKET_CREATE);
  }, []);

  return (
    <div className={useTeamsStyles ? classes.createTicketTeams : classes.createTicket}>
      <div className={classes.createTicketFormHeader}>
        <div className={classes.text}> Create Ticket</div>
        <Button text="Back" onClick={handleBack} />
      </div>
      <CreateTicketForm />
    </div>
  );
};

export default CreateTicketFormPage;
